import React from "react";
import { FaApple, FaGooglePlay } from "react-icons/fa6";

const DownloadApp: React.FC = () => {
  return (
    <section className="bg-white py-16">
      <div className="max-w-2xl mx-auto px-6 text-center">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-4">
          Workman Naija App
        </h1>
        <p className="text-gray-600 mb-10">
          We're building native iOS and Android apps so you can search,
          book and manage jobs on the go. For now, the website works great
          on mobile browsers — everything you need is already here.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <div
            className="flex items-center gap-3 border border-gray-300 rounded-lg px-6 py-3 text-left opacity-60 cursor-not-allowed select-none"
            aria-disabled="true"
            title="Coming soon"
          >
            {FaApple({ className: "h-8 w-8 text-gray-700" })}
            <div>
              <p className="text-xs text-gray-500">Coming soon on the</p>
              <p className="font-semibold text-gray-800">App Store</p>
            </div>
          </div>

          <div
            className="flex items-center gap-3 border border-gray-300 rounded-lg px-6 py-3 text-left opacity-60 cursor-not-allowed select-none"
            aria-disabled="true"
            title="Coming soon"
          >
            {FaGooglePlay({ className: "h-7 w-7 text-gray-700" })}
            <div>
              <p className="text-xs text-gray-500">Coming soon on</p>
              <p className="font-semibold text-gray-800">Google Play</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadApp;
